import React from 'react';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const AgreementNotice = () => {
  return (
 
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: 4,
            borderRadius: 4,
            textAlign: 'center',
            backgroundColor: '#ffffffee',
            boxShadow:'none'
          }}
        >
          <Typography variant="h5" fontWeight="bold" className='gn-actionbtn-color' gutterBottom>
            Complete Your Agreement
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Please complete the agreement process to avail our <strong>Music Distribution Services</strong>.
          </Typography>

          <Typography variant="h6" sx={{ mt: 2 }}>
            Contact Us Now:
          </Typography>

          <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <PhoneIcon color="action" />
              <Typography variant="body1">8126430111</Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <EmailIcon color="action" />
              <Typography variant="body1">anant.jain@gntunes.com</Typography>
            </Box>
          </Box>

          <Button
            variant="contained"
            className='gn-actionbtn'
            sx={{ mt: 4, px: 4 }}
            href="mailto:anant.jain@gnatunes.com"
          >
            Contact Us
          </Button>
        </Paper>
      </Container>
  );
};

export default AgreementNotice;
